import React, { useEffect } from 'react';
import { __ } from '../../translations';
import url, { getPreviousScreenRoute } from '../../helpers/url';
import { useNavigate } from 'react-router-dom';
import h from '../../helpers/common';
import { appConfig } from '../../config/app.config';
import { ILocalStorageConfigurationObject } from '../../types/ILocalStorage';
import { CACHE_CONFIG_TYPES } from '@intigral/constant';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { useConfiguration } from '../../hooks/useConfiguration';

interface VisitAppScreenProps {
    content: any;
}

const VisitAppScreen: React.FC<VisitAppScreenProps> = ({ content }) => {
    const { data: newConfig } = useConfiguration();

    if (!content) {
        return null;
    }
    const navigate = useNavigate();
    // Need to remove this class wherever player is rendered as Header component doesn't render on these pages.
    useEffect(() => {
        const bodyElement = document.querySelector('body');
        if (bodyElement) {
            bodyElement.classList.remove('cover-bg');
        }
    }, []);

    /** Setup mobile app links from CMS */
    const targetLinks = url.getMobileAppLinks();

    return (
        <section
            className="visitApp-main visit-app-bg"
            style={{
                display: h.isMobileAndTablet() ? 'flex' : 'none',
                backgroundImage: `url(${h.getImagizerUrl(
                    content.image,
                    newConfig?.imagizer?.components_images.APP_VOD_ITEM
                )})`,
                backgroundSize: 'cover',
            }}
        >
            <div
                className="visit-app-close"
                onClick={(e) => {
                    navigate(getPreviousScreenRoute());
                }}
            >
                <span className="icon-Arrow_scroll_left" />
            </div>
            <div className="visit-app-content">
                <h3 className="visit-app-title"> {content.text} </h3>
                <div className="movie-rating-main">
                    <span className="movie-genre"> {content.genre} </span>
                    <span className="parent-control"> {content.ratings} </span>
                    <span className="movie-year"> {content.year} </span>
                </div>
                <span className="visit-app-icon">
                    <img src="images/visit-app-icon.svg" alt="" />
                </span>
                <a href={targetLinks.mobileAppLink} className="backtoHome">
                    {__('watch_on_Jawwy_app')}
                </a>
            </div>
        </section>
    );
};

export default VisitAppScreen;
